<template>
  <UCard :ui="publicCard" class="my-8 hidden lg:block">
    <CottageContactDealResumeDetail
      :item="item"
    ></CottageContactDealResumeDetail>

    <template #footer>
      <CottageContactDealResumeTotal
        :item="item"
      ></CottageContactDealResumeTotal>
    </template>
  </UCard>

  <TContainer class="bg-escapadaGray-100 py-4 lg:hidden -mx-4 sm:-mx-6">
    <CottageContactDealResumeTotal :item="item"></CottageContactDealResumeTotal>
  </TContainer>
</template>

<script setup lang="ts">
import type { CottageContactDealPage } from '~/modules/views/cottage-contact-deal/entities/CottageContactDealPage'
import { publicCard } from '~/modules/design-system/utils/nuxt-ui-config/components/card'

type itemType = {
  deal: Pick<
    CottageContactDealPage['deal'],
    'total' | 'totalOld' | 'percentage' | 'rentUnitName' | 'people'
  >
}

interface propsInterface {
  item: itemType
}

defineProps<propsInterface>()
</script>
